import { useContext } from 'react';
import './pane-right-messages-item-template.scss';
import moment from 'moment';
import FileViewer from '../common/file-viewer';

//export default function MessagesItemTemplate (accountID, message, prev) {
export default function MessagesItemTemplate ({accountID, message, index}) {
    return (
        <div className="messages-item-template-container">
          
          
          
          <div
            className={
              accountID === message.recipientAccountID
                ? "messageLeft"
                : "messageRight"
            }
          >
            {message.text ? (
              <div dangerouslySetInnerHTML={{ __html: message.text }}></div>
            ) : message.files ? (
              <div>Файлове повідомлення</div>
            ) : null}
            <div className="messageInfo">{moment(message.ondate).format("LT")}</div>
          </div>
          <div
            className={
              accountID === message.recipientAccountID
                ? "messageFileLeft"
                : "messageFileRight"
            }
          >
            <FileViewer files={message.files}></FileViewer>
          </div>
        </div>
      );
};





